/**
 * Created by renjie.huang on 2017/11/10.
 */

import React from 'react';
import _ from "_";
import {
    Input,
    Icon,
    Tooltip
} from "@ucloud-fe/react-components";
import strength from '../../common/checkPassword.js';
// import che
import localeService from '../../service/localeService';
import { PopPassTip } from './style.jsx';
import { isMobile } from "../../service/deviceDetectService";
import { compose } from 'underscore';
import registerService from '../../service/registerService.js';
import userService from '../../service/userService.js';
import { any } from 'promise';
class RegisterNewPassword extends React.Component {
    constructor(props) {
        super(props);
        var self = this;
        self.state = {
            type: 'password',
            value: '',
            strength: 0,
            strengthText: "",
        }

    }


    onEyeClick() {
        var _type = this.state.type === 'password' ? 'text' : 'password';
        this.setState({
            type: _type
        })
    }

    get value() {
        return this.state.value;
    }
    checkPassword(value) {
        var self = this;
        const { passwardPolicy } = this.props
        const lowerRegex = /[a-z]/;
        const upperRegex = /[A-Z]/;
        const numRegex = /[0-9]/;
        const specialRegex = /[\(\)\`\~\!\@\#\$\%\^\&\*\-\+\=\_\|\{\}\[\]\:\;\'\<\>\,\.\?\/\\]/;
        const validRegex = /^([A-Z]|[a-z]|[0-9]|[\(\)\`\~\!\@\#\$\%\^\&\*\-\+\=\_\|\{\}\[\]\:\;\'\<\>\,\.\?\/\\])+$/;
        const typeList = []

        passwardPolicy.RequireUppercaseCharacters && typeList.push(upperRegex)
        passwardPolicy.RequireLowercaseCharacters && typeList.push(lowerRegex)
        passwardPolicy.RequireNumbers && typeList.push(numRegex)
        passwardPolicy.RequireSymbols && typeList.push(specialRegex)
        
        if (!value) {
            return localeService.getTranslate('UAC_ENPWD');
        } else if (!validRegex.test(value)) {
            // 含有非法字符
            return localeService.getTranslate('UACCOUNT_PASSWARD_15');
        } else if (value.length < passwardPolicy.MinimumPasswordLength || value.length > 32) {
            // 长度?-36
            return this.setPolicy();
        } else if (typeList.length && (typeList.reduce((sum, reg) => (reg.test(value) ? sum + 1 : sum), 0) < typeList.length)) {
            // 组合两种及以上
            return this.setPolicy();
        }
    }
    passwordChange(event) {
        var self = this;
        const { needStrength,passwardPolicy } = this.props;
        var _value = event.target.value;
        self.setState({
            value: _value
        })
        self.props.onChange(_value);
        if (!!needStrength) {
            var _strength = strength(_value,passwardPolicy.MinimumPasswordLength);
            var _copy = self.checkPassword(_value);
            self.setState({
                strength: _strength,
                strengthText: _copy
            })
            _copy ? self.props.onErrorChange(true) : self.props.onErrorChange(false)
            self.props.onStrengthChange(_strength)
        }
    }
    setPolicy = () => {
        const { passwardPolicy } = this.props

        const passwardPolicyArr = []
        let passwardPolicystr = ''
        const headStr = localeService.getTranslate('PASSWARD_TIP')
        let lengthStr = ''
        // const lengthStr = localeService.getTranslate('UACCOUNT_PASSWARD_13') + passwardPolicy.MinimumPasswordLength + '-' + localeService.getTranslate('UACCOUNT_PASSWARD1')
        if(passwardPolicy.MinimumPasswordLength === 32){
            lengthStr = localeService.getTranslate('UACCOUNT_PASSWARD_13') + localeService.getTranslate('UACCOUNT_PASSWARD1')
        }else{
            lengthStr =  localeService.getTranslate('UACCOUNT_PASSWARD_13') + passwardPolicy.MinimumPasswordLength + '-' + localeService.getTranslate('UACCOUNT_PASSWARD1')
        } 
        passwardPolicy.RequireUppercaseCharacters && passwardPolicyArr.push(localeService.getTranslate('UACCOUNT_PASSWARD_07'))
        passwardPolicy.RequireLowercaseCharacters && passwardPolicyArr.push(localeService.getTranslate('UACCOUNT_PASSWARD_08'))
        passwardPolicy.RequireNumbers && passwardPolicyArr.push(localeService.getTranslate('UACCOUNT_PASSWARD_09'))
        passwardPolicy.RequireSymbols && passwardPolicyArr.push(localeService.getTranslate('UACCOUNT_PASSWARD_11'))
        passwardPolicystr = passwardPolicyArr.join(localeService.getTranslate('UACCOUNT_PASSWORD_point'))
        if (passwardPolicyArr.length) {
            return headStr + passwardPolicystr + localeService.getTranslate('UACCOUNT_PASSWARD_14') + lengthStr
        }
        return lengthStr

    }
    getStrengthCopy(strength) {
        switch (strength) {
            case -1:
                return localeService.getTranslate('LOGIN40');
            case -2:
                return localeService.getTranslate('LOGIN41');

            case 1:
                return localeService.getTranslate('LOGIN35');
            case 2:
                return localeService.getTranslate('LOGIN36');
            case 3:
                return localeService.getTranslate('LOGIN36');
            case 4:
                return localeService.getTranslate('LOGIN37');
            default:
                return localeService.getTranslate('LOGIN34');
        }
    }

    render() {
        var self = this;
        const { type, strength, value, strengthText } = this.state;
        const { needTip = true, className, needStrength, placeholder } = this.props;
        var _icon = type === 'password' ? 'uc-input__icon icon__closeeye' : 'uc-input__icon icon__eye';
        var _clsName = className ? className : '';
        var _strengthClass = `pws-strength pwd-strength-${strength}`;
        var _passwordClassName = `pwd-rule u-mt10 pwd-rule-${strength}`;
        var _error = ((needStrength && strength != 0) || strengthText) ? true : false;

        return <div className="app-form-item">
            <Tooltip
                trigger={[needTip ? 'focus' : undefined]}
                arrow={false}
                placement={isMobile() ? "bottom" : "right"}
                popup={
                    <PopPassTip>
                        {this.setPolicy()}
                    </PopPassTip>
                }
                getPopupContainer={() => document.body}
            >
                <Input
                    onFocus={this.props.onFocus.bind(this)}
                    value={value} size="lg"
                    type={type} className={_clsName}
                    //  prefix={<Icon type="lock"></Icon>}
                    autoComplete="on"
                    maxLength="32"
                    placeholder={placeholder}
                    onBlur={this.props.onBlur.bind(this)}
                    onChange={this.passwordChange.bind(this)}
                    onKeyDown={this.props.onKeyDown.bind(this)}
                    suffix={<Icon onClick={this.onEyeClick.bind(this)}
                        type={_icon}></Icon>}></Input>
            </Tooltip>
            {
                !!needStrength ? <div className={_strengthClass}></div> : false
            }

            {
                !!needStrength && _error ? <p className='pwd-rule u-mt10 pwd-rule-1'>{strengthText}</p> : false
            }
        </div>
    }
}

RegisterNewPassword.defaultProps = {
    onKeyDown: () => { },
    onChange: () => { },
    onBlur: () => { },
    onErrorChange:()=>{ },
    onStrengthChange: () => { },
    onFocus: () => { }
}

export default RegisterNewPassword;


// WEBPACK FOOTER //
// src/pc/components/NewPassword.js